import * as Actions from "../../actions/app"
import { toggleIdInArray } from "utils/toggle-id-in-array"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_series_by_product: false,
  series_by_product: [],

  saving_serie_by_product: false,
  saved_serie_by_product: false,

  deleting_product_serie_ids: [],
  deleted_product_serie_ids: [],

  loading_product_series_by_search: false,
  product_series_by_search: [],

  loading_movement_items_to_series: false,
  movement_items_to_series: [],

  saving_movement_product_serie_ids: [],
  saved_movement_product_serie_ids: [],

  removing_movement_product_serie_ids: [],
  removed_movement_product_serie_ids: [],
}

const productSeriesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SERIES_BY_PRODUCT_ID: {
      return {
        ...state,
        loading_series_by_product: action.payload.loading,
        series_by_product: action.payload.data ?? state.series_by_product
      }
    }
    case Actions.SAVE_SERIE_BY_PRODUCT: {
      return {
        ...state,
        saving_serie_by_product: action.payload.saving ?? false,
        saved_serie_by_product: action.payload.saved ?? false,
        series_by_product: action.payload.data
          ? addOrUpdateObjectInArray(state.series_by_product, action.payload.data, 'idserieproducto', true)
          : state.series_by_product
      }
    }
    case Actions.DELETE_PRODUCT_SERIE_BY_ID: {
      return {
        ...state,
        deleting_product_serie_ids: toggleIdInArray(state.deleting_product_serie_ids, action.payload.deleting_id),
        deleted_product_serie_ids: toggleIdInArray(state.deleted_product_serie_ids, action.payload.deleted_id),
        series_by_product: state.series_by_product.filter(item => item.idserieproducto !== action.payload.deleted_id)
      }
    }
    case Actions.GET_PRODUCT_SERIES_BY_SEARCH: {
      return {
        ...state,
        loading_product_series_by_search: action.payload.loading,
        product_series_by_search: action.payload.data ?? state.product_series_by_search
      }
    }
    case Actions.GET_MOVEMENT_ITEMS_TO_SERIES: {
      return {
        ...state,
        loading_movement_items_to_series: action.payload.loading,
        movement_items_to_series: action.payload.data ?? state.movement_items_to_series
      }
    }
    case Actions.SAVE_MOVEMENT_PRODUCT_SERIE: {
      return {
        ...state,
        saving_movement_product_serie_ids: toggleIdInArray(state.saving_movement_product_serie_ids, action.payload.saving_id),
        saved_movement_product_serie_ids: toggleIdInArray(state.saved_movement_product_serie_ids, action.payload.saved_id),
        movement_items_to_series: action.payload.data
          ? state.movement_items_to_series.map(item => {
            const itemId = `${item.producto_id}-${item.unidad_medida_id}`
            return itemId === action.payload.saved_id
              ? { ...item, series_ingresadas: addOrUpdateObjectInArray(item.series_ingresadas, action.payload.data, 'idserieproducto', true) }
              : item
          })
          : state.movement_items_to_series
      }
    }
    case Actions.REMOVE_MOVEMENT_PRODUCT_SERIE: {
      return {
        ...state,
        removing_movement_product_serie_ids: toggleIdInArray(state.removing_movement_product_serie_ids, action.payload.removing_id),
        removed_movement_product_serie_ids: toggleIdInArray(state.removed_movement_product_serie_ids, action.payload.removed_id),
        movement_items_to_series: state.movement_items_to_series.map(item => ({
          ...item,
          series_ingresadas: item.series_ingresadas.filter(serie => serie.idserieproducto !== action.payload.removed_id)
        }))
      }
    }
    default: {
      return state
    }
  }
}
export default productSeriesReducer
